import React from 'react';
import Context from '../../assets/js/Context';
import Cookies from "universal-cookie";
import host from '../../assets/js/Host';
import axios from 'axios';
import { Row, Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Component from "@reactions/component";
import { SideSheet, Position, Pane, Dialog, Paragraph, Card, Heading, Table, Button } from 'evergreen-ui';
import Error from '@material-ui/icons/ReportProblem';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import SearchIcon from '@material-ui/icons/AttachFileOutlined';
import DownloadIcon from '@material-ui/icons/GetApp';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import 'react-toastify/dist/ReactToastify.css';
import MaterialDatatable from "material-datatable";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import qs from 'qs';
import * as moment from "moment-timezone";
import Login from '../common/login';
import exportFromJSON from 'export-from-json'
import DataTable from 'react-data-table-component';
import ReactToPrint from 'react-to-print-advanced';
import ExcelExport from './ExcelExport';
import { tr } from 'date-fns/locale';

// Spinner Component with inline styles
const SpinnerComponent = () => (
    <div style={{
        width: '100%',
        height: 'calc(100vh - 60px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        backgroundColor: '#f5f5f5'
    }}>
        <style>
            {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                
                .custom-spinner {
                    border: 8px solid #f3f3f3;
                    border-top: 8px solid #3498db;
                    border-radius: 50%;
                    width: 80px;
                    height: 80px;
                    animation: spin 1s linear infinite;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                }
                
                .loading-dots {
                    display: inline-block;
                    position: relative;
                    width: 80px;
                    height: 20px;
                }
                
                .loading-dots::after {
                    content: ' .';
                    animation: dots 1.5s infinite steps(5, end);
                }
                
                @keyframes dots {
                    0%, 20% {
                        content: '.';
                    }
                    40% {
                        content: '..';
                    }
                    60% {
                        content: '...';
                    }
                    80%, 100% {
                        content: '';
                    }
                }
            `}
        </style>
        <div className="custom-spinner"></div>
        <h2 style={{
            marginTop: '30px',
            fontSize: '24px',
            fontWeight: '600',
            color: '#333',
            textAlign: 'center'
        }}>
            جاري تحميل البيانات<span className="loading-dots"></span>
        </h2>
        <p style={{
            marginTop: '10px',
            fontSize: '16px',
            color: '#666'
        }}>
            يرجى الانتظار...
        </p>
    </div>
);

const columns2 = [
    { field: "admin", name: "المجهز", options: { width: 30, filter: true, sort: false, } },
    { field: "notes2", name: "المنتج", options: { width: 350, filter: true, sort: true, } },
    { field: "replacement", name: "استبدال ", options: { width: 20, filter: true, sort: true, } },
    { field: "items_count", name: "عدد القطع", options: { width: 20, filter: true, sort: true, } },
    { field: "safee", name: "الصافي", options: { width: 15, filter: true, sort: true, } },
    { field: "price", name: "السعر", options: { width: 15, filter: true, sort: true, } },
    { field: "government", name: "العنوان", options: { width: 500, filter: true, sort: true, } },
    { field: "phone", name: "رقم الهاتف", options: { width: 90, filter: true, sort: true, } },
    { field: "id", name: "رقم الوصل", options: { width: 90, filter: true, sort: false, } },
];

const columns = [
    {
        name: 'المجهز',
        selector: row => row.admin,
        sortable: true,
        width: "150px",
    },
    {
        name: 'المنتج',
        selector: row => row.notes2,
        sortable: true,
    },
    {
        name: 'القطع',
        selector: row => row.items_count,
        width: "100px",
    },
    {
        name: 'الصافي',
        selector: row => row.safee,
        width: "100px",
    },
    {
        name: 'السعر',
        selector: row => row.price,
        width: "100px",
    },
    {
        name: 'العنوان',
        selector: row => row.government + " / " + row.city,
        sortable: true,
        textAlign: "center",
        cell: row => <div style={{ fontSize: 15, textAlign: "center" }}>{row.government + " / " + row.city}</div>
    },
    {
        name: 'رقم الهاتف',
        selector: row => row.phone,
        width: "150px",
    },
    {
        name: 'رقم الوصل',
        selector: row => row.id,
        sortable: true,
        width: "180px",
    },
];

const columnsp = [
    {
        name: 'استبدال',
        selector: row => row.replacement,
        width: "100px",
    },
    {
        name: 'القطع',
        selector: row => row.items_count,
        width: "100px",
    },
    {
        name: 'الصافي',
        selector: row => row.safee,
        width: "100px",
    },
    {
        name: 'السعر',
        selector: row => row.price,
        width: "100px",
    },
    {
        name: 'العنوان',
        selector: row => row.government + " / " + row.city,
        sortable: true,
        textAlign: "center",
        cell: row => <div id="text-conca" style={{ overflow: "hidden", textOverflow: "ellipsis", maxWidth: "200px", fontSize: 15, textAlign: "center" }}>{row.government + " / " + row.city}</div>
    },
    {
        name: 'رقم الهاتف',
        selector: row => row.phone,
        width: "150px",
    },
    {
        name: 'رقم الوصل',
        selector: row => row.id,
        sortable: true,
        width: "180px",
    },
];

const customStyles = {
    rows: {
        style: {
            minHeight: '72px',
            border: 'solid 1px black',
            overflow: "hidden",
            display: "-webkit-box",
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            justifyContent: 'center',
            fontSize: '25px',
            fontWeight: 'bold',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            border: 'solid 1px black',
            fontSize: '20px',
            fontWeight: 'bold',
            justifyContent: 'center',
        },
    },
};

const options = {
    selectableRows: false,
    responsive: 'scroll',
    rowCursorHand: false,
    print: false,
    sort: false,
    rowsPerPage: 30000,
    search: false,
    filter: false,
    viewColumns: false,
    download: false,
    pagination: false,
    onSearchChange: (e) => {
        console.log(e);
    },
    textLabels: {
        body: {
            noMatch: " لم يتم العثور على سجلات مطابقة",
            toolTip: "فرز",
        },
        pagination: {
            next: "الصفحة التالية",
            previous: "الصفحة السابقة",
            rowsPerPage: "عدد الصفوف",
            displayRows: "من",
        },
        toolbar: {
            search: "بحث",
            downloadCsv: "تنزيل",
            print: "Print",
            viewColumns: " التحكم بالاعمدة",
            filterTable: "فلتر",
        },
        filter: {
            all: "الكل",
            title: "فلتر",
            reset: "إعادة تعيين",
        },
        viewColumns: {
            title: "عرض الأعمدة",
            titleAria: "إظهار / إخفاء أعمدة الجدول",
        },
    }
}

const conditionalRowStyles = [
    {
        when: row => row.check,
        style: {
            backgroundColor: "#d50014",
            userSelect: "none",
            color: 'white'
        }
    },
];

const cookies = new Cookies();
let id = 0

class Selles_Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            from: new Date(),
            to: new Date(),
            spin: true,
            serch: false,
            total: '',
            total_items: 0,
            total_orders: 0,
            items_cost: 0,
            orders_cost: 0,
            ordes2: [],
            ordes4: [],
            id: '',
            cash: '',
            cash_orders: '',
            total_price: "",
            changes: [],
            hasChange: false,
            isLoading: true,

            // 🚚 تسعير التوصيل حسب المحافظة
            is_priced: false,
            shipOpen: false,
            shipLoading: false,
            shipSaving: false,
            shipHasShiper: true,
            shipRows: [],
            shipBulk: ''
        }
        const urlParams = new URLSearchParams(window.location.search);
        let Getid = urlParams.get('id')
        let type = urlParams.get('type')
        this.setState({ id: Getid, type })
        this.Orders(Getid, type)
        id = Getid
    }

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MaterialDatatableBodyCell: {
                root: {
                    textAlign: 'center',
                    fontSize: '25px',
                    fontWeight: 'bold',
                    border: '2px solid'
                },
            },
            MuiTableCell: {
                root: {
                    textAlign: 'right',
                },
                head: {
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '25px',
                    border: '2px solid'
                }
            },
        }
    })

    componentDidMount() {
        let header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.get(host + `dashbord/shiper/all/`, { headers: header })
            .then(res => {
                this.setState({ shiper: res.data.shiper })
            })
            .catch(error => {
                console.log(error.response)
            });

        this.loadShipping();
    }

    // ════════════════════════════════════════════════════════════════════════
    // 🚚 تسعير التوصيل حسب المحافظة
    //    القائمة ما تنطبع ولا تنصدّر قبل ما تنسعّر.
    //    السعر ينكتب بـ order_from.shping_price وينحفظ كافتراضي للشركة.
    // ════════════════════════════════════════════════════════════════════════

    loadShipping = (openAfter) => {
        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        this.setState({ shipLoading: true });

        axios.get(host + `users/printed/orders/shipping/${id}`, { headers: header })
            .then(res => {
                const d = res.data.data || {};
                const rows = (d.governments || []).map(g => ({
                    government: g.government,
                    orders_count: g.orders_count,
                    orders_total: g.orders_total,
                    source: g.source,
                    price: (g.price === null || g.price === undefined) ? '' : String(g.price)
                }));
                this.setState({
                    shipLoading: false,
                    is_priced: !!d.is_priced,
                    shipHasShiper: d.has_shiper !== false,
                    shipRows: rows,
                    shipOpen: openAfter ? true : this.state.shipOpen
                });
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ shipLoading: false });
                toast.error('تعذّر جلب أسعار التوصيل', { position: "bottom-left", autoClose: 4000 });
            });
    }

    openShipping = () => {
        // نعيد الجلب دائماً قبل الفتح كي لا نعرض أسعاراً قديمة بعد تعديل من مكان آخر
        this.loadShipping(true);
        this.setState({ shipOpen: true });
    }

    setShipPrice = (i, value) => {
        // نسمح بالفاضي وبالكسور فقط — أي حرف يُرفض
        if (value !== '' && !/^\d*\.?\d*$/.test(value)) return;
        const rows = this.state.shipRows.slice();
        rows[i] = Object.assign({}, rows[i], { price: value });
        this.setState({ shipRows: rows });
    }

    applyShipBulk = () => {
        const v = this.state.shipBulk;
        if (v === '' || !isFinite(Number(v))) return;
        const rows = this.state.shipRows.map(r => Object.assign({}, r, { price: String(Number(v)) }));
        this.setState({ shipRows: rows });
    }

    shipIsComplete = () => {
        const rows = this.state.shipRows;
        if (!rows || rows.length === 0) return false;
        for (let i = 0; i < rows.length; i++) {
            const v = rows[i].price;
            if (v === '' || v === null || v === undefined) return false;
            const n = Number(v);
            if (!isFinite(n) || n < 0) return false;
        }
        return true;
    }

    saveShipping = () => {
        if (!this.shipIsComplete() || this.state.shipSaving) return;

        const header = { "Content-Type": "application/json", token: cookies.get("token") };
        const prices = this.state.shipRows.map(r => ({
            government: r.government,
            price: Number(r.price)
        }));

        this.setState({ shipSaving: true });

        axios.post(host + `users/printed/orders/shipping/${id}`, { prices }, { headers: header })
            .then(res => {
                const d = res.data.data || {};
                this.setState({ shipSaving: false, shipOpen: false, is_priced: true, shipBulk: '' });
                toast.success(`تم تسعير ${d.updated_orders || 0} طلب`, { position: "bottom-left", autoClose: 3000 });
                // إعادة تحميل الكشف كي يظهر الصافي بالأسعار الجديدة
                this.Orders(id, this.state.type);
                this.loadShipping();
            })
            .catch(error => {
                console.log(error.response);
                this.setState({ shipSaving: false });
                const msg = (error.response && error.response.data && error.response.data.message)
                    ? error.response.data.message
                    : 'تعذّر حفظ الأسعار';
                toast.error(msg, { position: "bottom-left", autoClose: 5000 });
            });
    }

    renderShippingDialog = () => {
        const rows = this.state.shipRows;
        const complete = this.shipIsComplete();
        const totalShip = rows.reduce((a, r) => a + (Number(r.price) || 0) * (Number(r.orders_count) || 0), 0);
        const totalOrders = rows.reduce((a, r) => a + (Number(r.orders_count) || 0), 0);
        const blended = totalOrders > 0 ? (totalShip / totalOrders) : 0;

        return (
            <Dialog
                isShown={this.state.shipOpen}
                title={`أسعار التوصيل — ${this.state.name || ''}`}
                onCloseComplete={() => this.setState({ shipOpen: false })}
                confirmLabel={this.state.shipSaving ? 'جاري الحفظ…' : 'حفظ الأسعار'}
                cancelLabel="إلغاء"
                isConfirmDisabled={!complete || this.state.shipSaving}
                isConfirmLoading={this.state.shipSaving}
                onConfirm={this.saveShipping}
                width={680}
            >
                <div dir="rtl" style={{ textAlign: 'right' }}>
                    {this.state.shipLoading && <p>جاري التحميل…</p>}

                    {!this.state.shipHasShiper && (
                        <div style={{
                            background: '#fff4e5', border: '1px solid #ffb74d',
                            borderRadius: 6, padding: 10, marginBottom: 12, fontSize: 14
                        }}>
                            ⚠️ شركة «{this.state.name}» غير مسجّلة بجدول شركات التوصيل — الأسعار
                            راح تنكتب على طلبات هذي القائمة بس، وما تنحفظ كافتراضي للقوائم الجاية.
                        </div>
                    )}

                    <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 14 }}>
                        <span style={{ fontSize: 14 }}>تطبيق سعر واحد على الكل:</span>
                        <input
                            type="text"
                            value={this.state.shipBulk}
                            onChange={(e) => {
                                const v = e.target.value;
                                if (v === '' || /^\d*\.?\d*$/.test(v)) this.setState({ shipBulk: v });
                            }}
                            style={{ width: 90, padding: '4px 8px', textAlign: 'center', border: '1px solid #ccc', borderRadius: 4 }}
                        />
                        <button className="btn btn-sm btn-outline-secondary" onClick={this.applyShipBulk}>طبّق</button>
                    </div>

                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 15 }}>
                        <thead>
                            <tr style={{ background: '#f3f3f3' }}>
                                <th style={{ padding: 8, border: '1px solid #ddd' }}>المحافظة</th>
                                <th style={{ padding: 8, border: '1px solid #ddd' }}>عدد الطلبات</th>
                                <th style={{ padding: 8, border: '1px solid #ddd' }}>مجموع المبالغ</th>
                                <th style={{ padding: 8, border: '1px solid #ddd' }}>سعر التوصيل</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, i) => {
                                const empty = r.price === '';
                                return (
                                    <tr key={i} style={{ background: empty ? '#fff6f6' : 'white' }}>
                                        <td style={{ padding: 8, border: '1px solid #ddd' }}>
                                            {r.government || <span style={{ color: '#b00' }}>(بدون محافظة)</span>}
                                            {r.source === 'default' && (
                                                <span style={{ fontSize: 11, color: '#777', marginRight: 6 }}>• افتراضي محفوظ</span>
                                            )}
                                        </td>
                                        <td style={{ padding: 8, border: '1px solid #ddd', textAlign: 'center' }}>{r.orders_count}</td>
                                        <td style={{ padding: 8, border: '1px solid #ddd', textAlign: 'center' }}>{r.orders_total}</td>
                                        <td style={{ padding: 8, border: '1px solid #ddd', textAlign: 'center' }}>
                                            <input
                                                type="text"
                                                value={r.price}
                                                onChange={(e) => this.setShipPrice(i, e.target.value)}
                                                style={{
                                                    width: 90, padding: '4px 8px', textAlign: 'center',
                                                    border: empty ? '1px solid #d50014' : '1px solid #ccc',
                                                    borderRadius: 4
                                                }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    <div style={{ marginTop: 14, fontSize: 15, fontWeight: 'bold' }}>
                        مجموع أجور التوصيل: {Math.round(totalShip * 100) / 100}
                        <span style={{ marginRight: 18, fontWeight: 'normal' }}>
                            المعدّل لكل طلب: {Math.round(blended * 100) / 100}
                        </span>
                    </div>

                    {!complete && (
                        <p style={{ color: '#d50014', marginTop: 10, fontSize: 14 }}>
                            لازم تحدّد سعر لكل محافظة قبل الحفظ.
                        </p>
                    )}
                </div>
            </Dialog>
        );
    }

    Orders(id, type) {
        this.setState({ isLoading: true });

        var header = { "Content-Type": "application/json", token: cookies.get("token") };
        axios.get(host + `users/printed/orders/get/${id}?type=1`, { headers: header })
            .then(res => {
                let arr = [];
                let items = res.data.data.orders
                let ordes3 = []
                let ordes2 = []
                let ordes4 = []

                for (let i = 0; i < items.length; i++) {
                    let check = false;
                    if (!items[i].admin) {
                        check = true
                    }
                    let obj = {
                        i: i + 1,
                        check,
                        id: items[i].id,
                        phone: items[i].phone,
                        name: items[i].name,
                        government: items[i].government + "/" + items[i].city,
                        city: items[i].city,
                        price: items[i].price,
                        safee: items[i].saffe,
                        notes2: items[i].notes2,
                        page: items[i].page,
                        replacement: "لا",
                        items_count: items[i].items_count,
                        createdAt: items[i].createdAt,
                        admin: items[i].admin
                    };

                    let price = items[i].price
                    let nots = "";
                    let name = 0;
                    if (items[i].notes) {
                        nots = items[i].notes
                    }
                    if (items[i].name) {
                        name = items[i].name
                    }
                    let gov = "";
                    if (items[i].government == "المثنى") {
                        gov = "سماوه"
                    } else {
                        gov = items[i].government
                    }

                    let obj2 = {
                        'رقم الوصل': items[i].id,
                        'التاريخ': moment(new Date()).format('YYYY/MM/DD'),
                        'العميل': items[i].page,
                        'مبلغ البضاعة': price * 1000,
                        'المحافظة': gov,
                        'المنطقة': items[i].city,
                        'اسم المستلم': name,
                        'هاتف المستلم': items[i].phone,
                        'عنوان المستلم': gov + " / " + items[i].city,
                        'الملاحظات': nots,
                        'استبدال': 0,
                    };

                    if (items[i].replacement == 1) {
                        obj2['استبدال'] = "نعم"
                        obj.replacement = "نعم"
                    } else {
                        obj2['استبدال'] = "لا"
                    }

                    let obj3 = {
                        'قابل للكسر': "Y",
                        'عدد': items[i].items_count,
                        'الملاحظات': nots,
                        'رقم الهاتف': items[i].phone,
                        'اسم المستلم': name,
                        'المحافظة': gov,
                        "تفاصيل العنوان": items[i].city,
                        'المبلغ عراقي': price * 1000,
                        'رقم الوصل': items[i].id,
                    };

                    let govCode = items[i].government
                    let rep = "طلب جديد"

                    if (items[i].replacement == 1) {
                        rep = "استبدال"
                    }
                    else if (items[i].government == "بغداد") {
                        govCode = "بغداد"
                    }
                    else if (items[i].government.replace(/\s/g, '') == "بغداد") {
                        govCode = "بغداد"
                    }
                    else if (items[i].government == "ديالى") {
                        govCode = "ديالى"
                    }
                    else if (items[i].government == "دهوك") {
                        govCode = "دهوك"
                    }
                    else if (items[i].government == "كربلاء") {
                        govCode = "كربلاء"
                    }
                    else if (items[i].government == "بابل") {
                        govCode = "بابل"
                    }
                    else if (items[i].government == "النجف") {
                        govCode = "نجف"
                    }
                    else if (items[i].government == "البصرة") {
                        govCode = "البصره"
                    }
                    else if (items[i].government == "اربيل") {
                        govCode = "اربيل"
                    }
                    else if (items[i].government == "كركوك") {
                        govCode = "كركوك"
                    }
                    else if (items[i].government == "السليمانية") {
                        govCode = "سليمانيه"
                    }
                    else if (items[i].government == "السليمانية ") {
                        govCode = "سليمانيه"
                    }
                    else if (items[i].government == "موصل") {
                        govCode = "نينوى"
                    }
                    else if (items[i].government == "واسط") {
                        govCode = "واسط"
                    }
                    else if (items[i].government == "ذي قار") {
                        govCode = "ذي قار"
                    }
                    else if (items[i].government == "صلاح الدين") {
                        govCode = "صلاح الدين"
                    }
                    else if (items[i].government == "الأنبار") {
                        govCode = "الانبار"
                    }
                    else if (items[i].government == "المثنى") {
                        govCode = "سماوه"
                    }
                    else if (items[i].government == "نينوى") {
                        govCode = "نينوى"
                    }
                    else if (items[i].government == "القادسية") {
                        govCode = "ديوانيه"
                    }
                    else if (items[i].government == "ميسان") {
                        govCode = "عماره"
                    }

                    let obj4 = {
                        "اسم الزبون": items[i].id,
                        'رقم الهاتف الاساسي': items[i].phone,
                        'رقم الهاتف الثانوي': 0,
                        'المحافظة': items[i].govName,
                        'المنطقة': items[i].corrected,
                        'اقرب نقطة دالة': items[i].city,
                        'نوع البضاعه': items[i].notes2,
                        'عدد القطع': items[i].items_count,
                        'السعر مع التوصيل': price * 1000,
                        'حجم الطلب': "عادي",
                        'الملاحظات': items[i].notes,
                        'نوع الطلب': rep,
                        'رقم الطلب لدى الشركة': items[i].id,
                    };
                    function getGovCode(government) {
                        const mapping = {
                            "بغداد": "بغداد",
                            "ديالى": "ديالى",
                            "دهوك": "دهوك",
                            "كربلاء": "كربلاء",
                            "بابل": "بابل الحلة",
                            "النجف": "النجف",
                            "البصرة": "البصرة",
                            "اربيل": "اربيل",
                            "أربيل": "اربيل",
                            "كركوك": "كركوك",
                            "السليمانية": "السليمانيه",
                            "موصل": "موصل",
                            "الموصل": "موصل",
                            "واسط": "الكوت واسط",
                            "ذي قار": "الناصرية ذي قار",
                            "صلاح الدين": "صلاح الدين",
                            "الأنبار": "الانبار",
                            "المثنى": "السماوة المثنى",
                            "نينوى": "موصل",
                            "القادسية": "الديوانية",
                            "ميسان": "العمارة ميسان"
                        };

                        const cleanGov = government?.trim();

                        return mapping[cleanGov] ||
                            mapping[cleanGov?.replace(/\s/g, '')] ||
                            null;
                    }

                    let boxyobj = {
                        "client name": items[i].name,
                        "primary phone number": items[i].phone,
                        "secondary phone number": null,
                        "province": getGovCode(items[i].government),
                        "area": "",
                        "address": items[i].city,
                        "delivery instruction": items[i].notes,
                        "merchant order id": items[i].id,
                        "product name": items[i].notes2,
                        "qty": 1,
                        "price": items[i].price * 1000,
                        "package size": "S",
                        "is fragile": true,
                        "payment on delivery": true,
                        "shipment fee by customer": false,
                        "type": "DEFAULT",
                        "fee_customer_payable": "",

                    };
                    if (items[i].replacement == 1) {
                        boxyobj['type'] = "EXCHANGE"
                    }

                    arr.push(obj);
                    ordes2.push(obj2)
                    ordes3.push(obj3)

                    if (res.data.data.name == "الوسيط") {
                        ordes4.push(obj4)
                    } else if (res.data.data.name == "بوكسي") {
                        ordes4.push(boxyobj)
                    } else {
                        ordes4.push(obj2)
                    }
                }

                var totalChild = arr.reduce((accum, item) => accum + (item.safee), 0)

                setTimeout(() => {
                    this.setState({
                        orders_count: items.length,
                        orders: arr,
                        spin: false,
                        hasChange: res.data.data.hasChange,
                        total_items: res.data.data.items_sum,
                        total_orders: res.data.data.order_count,
                        items_cost: res.data.data.items_cost,
                        orders_cost: res.data.data.sells,
                        ordes2,
                        ordes3,
                        ordes4,
                        cash_orders: res.data.data.cash_orders,
                        cash: res.data.data.cash,
                        total_price: totalChild,
                        name: res.data.data.name,
                        is_priced: !!res.data.data.is_priced,
                        isLoading: false
                    });
                }, 500);
            })
            .catch(error => {
                console.log(error.response)
                this.setState({ isLoading: false });
                toast.error('حدث خطأ في تحميل البيانات', {
                    position: "bottom-left",
                    autoClose: 5000,
                });
            });

        axios.get(host + `dashbord/list/change/${id}`, { headers: header })
            .then(res => {
                console.log(res.data.changes);
                this.setState({ changes: res.data.changes })
            })
            .catch(error => {
                console.log(error.response)
            });
    }

    handleChangeFrom = date => {
        console.log(date);
        this.setState({
            from: date
        });
    };

    handleChangeTo = date => {
        this.setState({
            to: date
        });
    };

    download() {
        const data = this.state.ordes2
        const fileName = `Sheet`
        const exportType = exportFromJSON.types.xls
        exportFromJSON({ data, fileName, exportType })
    }

    download2() {
        const data = this.state.ordes3
        const fileName = `Sheet0`
        const exportType = exportFromJSON.types.xls
        exportFromJSON({ data, fileName, exportType })
    }

    // دالة تحميل ملف CSV لبوكسي
    downloadBoxyCSV = () => {
        const data = this.state.ordes4;
        if (!data || data.length === 0) {
            toast.error('لا توجد بيانات للتحميل', {
                position: "bottom-left",
                autoClose: 3000,
            });
            return;
        }

        // الحصول على أسماء الأعمدة من أول عنصر
        const headers = Object.keys(data[0]);

        // إنشاء محتوى CSV
        let csvContent = '\uFEFF'; // BOM للتعامل مع الأحرف العربية

        // إضافة صف العناوين
        csvContent += headers.join(',') + '\n';

        // إضافة صفوف البيانات
        data.forEach(row => {
            const values = headers.map(header => {
                let value = row[header];
                // التعامل مع القيم التي تحتوي على فاصلة أو علامات اقتباس
                if (value === null || value === undefined) {
                    value = '';
                }
                value = String(value);
                // إذا كانت القيمة تحتوي على فاصلة أو علامة اقتباس أو سطر جديد، نضعها بين علامتي اقتباس
                if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                    value = '"' + value.replace(/"/g, '""') + '"';
                }
                return value;
            });
            csvContent += values.join(',') + '\n';
        });

        // إنشاء Blob وتحميل الملف
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const fileName = `Boxy_${id}_${moment(new Date()).format('YYYY-MM-DD')}.csv`;
        saveAs(blob, fileName);

        toast.success('تم تحميل ملف CSV بنجاح', {
            position: "bottom-left",
            autoClose: 3000,
        });
    }

    render() {
        if (cookies.get("token")) {
            return (
                <Context.Consumer>
                    {ctx => {
                        if (this.state.isLoading) {
                            return <SpinnerComponent />
                        }

                        return (
                            <div>
                                {this.renderShippingDialog()}

                                {/* 🚚 زر التسعير — الطباعة والتصدير معطّلة قبله */}
                                <div style={{ margin: '10px 0' }}>
                                    <button
                                        className={this.state.is_priced ? "btn btn-outline-primary" : "btn btn-danger"}
                                        style={{ margin: 10, fontSize: "20px", fontWeight: "bold" }}
                                        onClick={this.openShipping}
                                    >
                                        {this.state.is_priced ? '✏️ تعديل أسعار التوصيل' : '🚚 تحديد أسعار التوصيل'}
                                    </button>

                                    {!this.state.is_priced && (
                                        <span style={{ fontSize: 16, color: '#d50014', fontWeight: 'bold' }}>
                                            القائمة غير مسعّرة — الطباعة والتصدير معطّلة
                                        </span>
                                    )}
                                </div>

                                {this.state.is_priced && (
                                    <div>
                                        <div id='navDashContiner'>
                                            <Button marginRight={16} appearance="primary" intent="success"
                                                iconBefore={SearchIcon}
                                                height={45}
                                            >
                                                <ExcelExport data={this.state.ordes4} fileName={id} />
                                            </Button>

                                            {/* زر تحميل CSV لبوكسي */}
                                            {this.state.name === "بوكسي" && (
                                                <Button
                                                    marginRight={16}
                                                    appearance="primary"
                                                    intent="warning"
                                                    iconBefore={DownloadIcon}
                                                    height={45}
                                                    onClick={this.downloadBoxyCSV}
                                                    style={{ backgroundColor: '#ff9800', color: 'white' }}
                                                >
                                                    تحميل CSV بوكسي
                                                </Button>
                                            )}
                                        </div>

                                        <br />
                                        <ReactToPrint
                                            content={() => this.PrintComp}
                                            trigger={() => (
                                                <button style={{ margin: 10, fontSize: "20px", fontWeight: "bold" }} className="btn btn-primary">طباعة كشف</button>
                                            )}
                                        />
                                        <button style={{ margin: 10, fontSize: "20px", fontWeight: "bold" }} className="btn btn-success" onClick={() => {
                                            window.location.href = `/printLabel?id=${id}`
                                        }}>طباعة الطلبات</button>
                                    </div>
                                )}

                                <div className='dayle_orders' ref={(refer) => (this.PrintComp = refer)}>
                                    <br></br>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                                            <h5 style={{ textAlign: 'right', marginBottom: '15px' }}> اسم المستلم </h5>
                                            <br />
                                            <h5 style={{ textAlign: 'right', marginBottom: '15px' }}> التوقيع </h5>
                                            <br />
                                        </div>
                                        <div style={{ textAlign: 'right', marginRight: '15px' }}>
                                            <h5>التاريخ: {moment(new Date()).format('DD/MM/YYYY')}</h5>
                                            <h5>رقم القائمة: {id}</h5>
                                            <h5> اسم شركة التوصيل: {this.state.name}</h5>
                                            <h5>  عدد الطلبات :{this.state.orders_count} </h5>
                                            <h5> المبلغ الكلي  :{this.state.total_price} </h5>
                                            <p>
                                                <Component initialState={{ isShown: false, changes: [] }}>
                                                    {({ state, setState, }) => (
                                                        <Pane>
                                                            <SideSheet
                                                                position={Position.LEFT}
                                                                isShown={state.isShown}
                                                                onCloseComplete={() => setState({ isShown: false })}
                                                                containerProps={{
                                                                    display: 'flex',
                                                                    flex: '1',
                                                                    flexDirection: 'column'
                                                                }}
                                                            >
                                                                <Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
                                                                    <Pane padding={16}>
                                                                        <Heading size={600}>التغيرات</Heading>
                                                                    </Pane>
                                                                </Pane>
                                                                <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                                                                    <Table>
                                                                        <Table.Head>
                                                                            <Table.TextHeaderCell>التاريخ</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>السعر الجديد</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>السعر القديم</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>المستخدم</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>الحالة</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>رقم الطلب </Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>#</Table.TextHeaderCell>
                                                                        </Table.Head>
                                                                        <Table.Body height={240}>
                                                                            {this.state.changes.map((profile, i) => (
                                                                                <Table.Row key={i}>
                                                                                    <Table.TextCell style={{ fontSize: 10 }}>{moment(profile.createdAt).tz('Asia/baghdad').format('MM/DD')}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.new_value}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.value}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.user}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.status}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.order.id}</Table.TextCell>
                                                                                    <Table.TextCell>{i}</Table.TextCell>
                                                                                </Table.Row>
                                                                            ))}
                                                                        </Table.Body>
                                                                    </Table>
                                                                </Pane>
                                                            </SideSheet>
                                                            <Error onClick={() => {
                                                                axios.get(host + `dashbord/list/change/${id}`,)
                                                                    .then(res => {
                                                                        setState({ changes: res.data.changes })
                                                                    })
                                                                    .catch(error => {
                                                                        console.log(error.response)
                                                                    });
                                                                setState({ isShown: true })
                                                            }} style={this.state.hasChange == true ? { color: '#ffc107', cursor: 'pointer', fontSize: 35 } : { display: 'none' }}
                                                            />
                                                        </Pane>
                                                    )}
                                                </Component>
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='DataTableContiner'>
                                            <DataTable highlightOnHover
                                                pointerOnHover direction={'center'}
                                                conditionalRowStyles={conditionalRowStyles}
                                                customStyles={customStyles}
                                                columns={columnsp}
                                                data={this.state.orders}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ textAlign: 'left', marginLeft: '15px' }}>
                                            <h5 style={{ textAlign: 'right', marginBottom: '15px' }}> اسم المستلم </h5>
                                            <br />
                                            <h5 style={{ textAlign: 'right', marginBottom: '15px' }}> التوقيع </h5>
                                            <br />
                                        </div>
                                        <div style={{ textAlign: 'right', marginRight: '15px' }}>
                                            <h5>التاريخ: {moment(new Date()).format('DD/MM/YYYY')}</h5>
                                            <h5>رقم القائمة: {id}</h5>
                                            <h5> اسم شركة التوصيل: {this.state.name}</h5>
                                            <h5>  عدد الطلبات :{this.state.orders_count} </h5>
                                            <h5> المبلغ الكلي  :{this.state.total_price} </h5>
                                            <p>
                                                <Component initialState={{ isShown: false, changes: [] }}>
                                                    {({ state, setState, }) => (
                                                        <Pane>
                                                            <SideSheet
                                                                position={Position.LEFT}
                                                                isShown={state.isShown}
                                                                onCloseComplete={() => setState({ isShown: false })}
                                                                containerProps={{
                                                                    display: 'flex',
                                                                    flex: '1',
                                                                    flexDirection: 'column'
                                                                }}
                                                            >
                                                                <Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
                                                                    <Pane padding={16}>
                                                                        <Heading size={600}>التغيرات</Heading>
                                                                    </Pane>
                                                                </Pane>
                                                                <Pane flex="1" overflowY="scroll" background="tint1" padding={16}>
                                                                    <Table>
                                                                        <Table.Head>
                                                                            <Table.TextHeaderCell>التاريخ</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>السعر الجديد</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>السعر القديم</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>المستخدم</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>الحالة</Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>رقم الطلب </Table.TextHeaderCell>
                                                                            <Table.TextHeaderCell>#</Table.TextHeaderCell>
                                                                        </Table.Head>
                                                                        <Table.Body height={240}>
                                                                            {this.state.changes.map((profile, i) => (
                                                                                <Table.Row key={i}>
                                                                                    <Table.TextCell style={{ fontSize: 10 }}>{moment(profile.createdAt).tz('Asia/baghdad').format('MM/DD')}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.new_value}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.value}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.user}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.status}</Table.TextCell>
                                                                                    <Table.TextCell>{profile.order.id}</Table.TextCell>
                                                                                    <Table.TextCell>{i}</Table.TextCell>
                                                                                </Table.Row>
                                                                            ))}
                                                                        </Table.Body>
                                                                    </Table>
                                                                </Pane>
                                                            </SideSheet>
                                                            <Error onClick={() => {
                                                                axios.get(host + `dashbord/list/change/${id}`,)
                                                                    .then(res => {
                                                                        setState({ changes: res.data.changes })
                                                                    })
                                                                    .catch(error => {
                                                                        console.log(error.response)
                                                                    });
                                                                setState({ isShown: true })
                                                            }} style={this.state.hasChange == true ? { color: '#ffc107', cursor: 'pointer', fontSize: 35 } : { display: 'none' }}
                                                            />
                                                        </Pane>
                                                    )}
                                                </Component>
                                            </p>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='DataTableContiner'>
                                            <DataTable highlightOnHover
                                                pointerOnHover direction={'center'}
                                                conditionalRowStyles={conditionalRowStyles}
                                                customStyles={customStyles}
                                                columns={columns}
                                                data={this.state.orders}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <ToastContainer
                                    position="bottom-left"
                                    autoClose={10000}
                                    hideProgressBar={false}
                                    newestOnTop={false}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover
                                />
                            </div>
                        )
                    }}
                </Context.Consumer>
            )
        }
        else {
            return (
                <Login />
            )
        }
    }
}

export default Selles_Reports;